export class Title {
  titleId
  typeId
  title

  constructor(title = {}) {
    this.titleId = title.titleId ? String(title.titleId) : ''
    this.typeId = title.typeId ? String(title.typeId) : ''
    this.title = title.title ? String(title.title) : ''
  }
}